import { skeletonize } from "../../helpers/skeletonize";
import { Skeleton } from "../skeleton/Skeleton.Parts";
import {
  Button,
  SkeletonProps as Props,
  SELECTION_HEIGHTS,
} from "./Selection.Parts";

const ButtonSkeleton = skeletonize(Button);

export const SelectionSkeleton = ({
  value,
  $size = "medium",
  $variant,
}: Props) =>
  value ? (
    <ButtonSkeleton $size={$size} $variant={$variant}>
      {value}
    </ButtonSkeleton>
  ) : (
    <Skeleton $height={`${SELECTION_HEIGHTS[$size]}rem`} $width="10rem" />
  );
